/**
 * Generated runtime TestId mirror for frontend/src/pages/JobBuilderPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const JobBuilderPageTestIds = {
  badgeUnsaved: "badge-unsaved",
  btnAddInput: "btn-add-input",
  btnApplyConfig: "btn-apply-config",
  btnBack: "btn-back",
  btnCancel: "btn-cancel",
  btnConflictCancel: "btn-conflict-cancel",
  btnConflictReload: "btn-conflict-reload",
  btnDiscard: "btn-discard",
  btnKeepEditing: "btn-keep-editing",
  btnRetryPalette: "btn-retry-palette",
  btnSave: "btn-save",
  btnTestScript: "btn-test-script",
  builderError: "builder-error",
  builderLoading: "builder-loading",
  builderLoadingPanels: "builder-loading-panels",
  configBeanMethod: "config-bean-method",
  configDelay: "config-delay",
  configGroovyScript: "config-groovy-script",
  configReadonlyHint: "config-readonly-hint",
  createJobDialog: "create-job-dialog",
  cronPreview: "cron-preview",
  editorScript: "editor-script",
  emptyChain: "empty-chain",
  hintNoTasks: "hint-no-tasks",
  inputCronExpression: "input-cron-expression",
  inputDelayDuration: "input-delay-duration",
  inputDelayName: "input-delay-name",
  inputJobDescription: "input-job-description",
  inputJobKey: "input-job-key",
  inputJobName: "input-job-name",
  inputTaskName: "input-task-name",
  inputTimeout: "input-timeout",
  jobBuilderPage: "job-builder-page",
  paletteEmpty: "palette-empty",
  paletteError: "palette-error",
  paletteLoading: "palette-loading",
  selectPriority: "select-priority",
  switchSqlWriteAccess: "switch-sql-write-access",
  taskChainEditor: "task-chain-editor",
  taskConfigPanel: "task-config-panel",
  taskPalette: "task-palette",
  testError: "test-error",
  testOutput: "test-output",
  btnAdd: (item_id: string) => `btn-add-${item_id}`,
  btnAddPrefix: () => "btn-add-" as TestIdPrefix,
  btnDeleteTask: (task_id: string) => `btn-delete-task-${task_id}`,
  btnDeleteTaskPrefix: () => "btn-delete-task-" as TestIdPrefix,
  btnEditScript: (taskIndex: string) => `btn-edit-script-${taskIndex}`,
  btnEditScriptPrefix: () => "btn-edit-script-" as TestIdPrefix,
  dragHandle: (taskIndex: string) => `drag-handle-${taskIndex}`,
  dragHandlePrefix: () => "drag-handle-" as TestIdPrefix,
  lock: (taskIndex: string) => `lock-${taskIndex}`,
  lockPrefix: () => "lock-" as TestIdPrefix,
  paletteItem: (item_id: string) => `palette-item-${item_id}`,
  paletteItemPrefix: () => "palette-item-" as TestIdPrefix,
  taskItem: (taskIndex: string) => `task-item-${taskIndex}`,
  taskItemPrefix: () => "task-item-" as TestIdPrefix,
  btnRemoveInput: (index: number) => `btn-remove-input-${index}`,
  btnRemoveInputPrefix: () => "btn-remove-input-" as TestIdPrefix,
  inputKey: (index: number) => `input-key-${index}`,
  inputKeyPrefix: () => "input-key-" as TestIdPrefix,
  inputValue: (index: number) => `input-value-${index}`,
  inputValuePrefix: () => "input-value-" as TestIdPrefix
} as const;
